// Chemin public des chunks chargés à la demande via import() (dist/chunks/).
// Déduit de wp_data.assets_path (…/themes/AD/static/) pour fonctionner quel que
// soit le chemin d'installation. Doit rester le premier import de app.js.
if (window.wp_data?.assets_path) {
  __webpack_public_path__ = window.wp_data.assets_path.replace(/static\/$/, "");
}
